import { checkResponse } from "src/components/js/statics1";
import asiakasClass from "./asiakasClass";
import authClass from "../auth/auth";
import { fetchAsiakasPersonSettings } from "../auth/asiakasAuthClass";
import {
  asiakas_cacheName,
  cache_clear,
  cache_read,
  cache_write,
} from "src/components/js/CacheFunctions";

export async function asiakas_createY(
  yTunnus,
  creatorEmail,
  token,
  keikkaId,
  ownerAsiakasId,
  asiakasNimi = null
) {
  cache_clear(asiakas_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      yTunnus: yTunnus,
      email: creatorEmail,
      keikkaId: keikkaId,
      ownerAsiakasId: ownerAsiakasId,
      asiakasNimi: asiakasNimi,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/asiakas/createY",
    requestOptions
  );
  const cResponse = await checkResponse(response, "asiakasClass.js:createNewAsiakas");
  if (!cResponse.success) return false;
  return cResponse.data.returnValue;
}
export async function asiakas_search(
  ownerAsiakasId,
  searchString,
  token,
  signal = null,
  usingFullTextSearch = true
) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ownerAsiakasId: ownerAsiakasId,
      searchString: searchString,
      usingFullTextSearch: usingFullTextSearch,
      signal: signal,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/asiakas/search/",
    requestOptions
  );
  const cResponse = await checkResponse(response, "searchAsiakas");
  if (!cResponse.success) {
    console.log(cResponse.message);
    return [];
  }
  const result = cResponse.data;
  return result;
}
export async function asiakas_fetch(
  user,
  asiakasId,
  token,
  keikkaId,
  laskuttajaAsiakasId,
  loadAuth = true, // load auth data from db to asiakasPersonSettings
  useCache = true,
  options = {}
) {
  if (keikkaId?.keikkaId > 0) keikkaId = keikkaId.keikkaId;
  //  const keikkaId = keikkaData?keikkaData.keikkaId:0;
  if (user == null) return;
  const personId = user.personId;
  //  const laskuttajaAsiakasId = person.oletusAdminYritysId;
  if (asiakasId == null) return;
  if (asiakasId === 0) return;
  if (keikkaId == null) keikkaId = 0;
  if (laskuttajaAsiakasId == null) laskuttajaAsiakasId = 0;
  try {
    const url = "/api/asiakas/get/" + asiakasId + "/" + laskuttajaAsiakasId + "/" + keikkaId;
    const fullUrl = import.meta.env.VITE_SERVER_URL + url;
    const cache = useCache && (await cache_read(asiakas_cacheName, fullUrl));
    if (cache) return cache;

    const keikkaAsiakas = new asiakasClass();
    const globalAsiakas = new asiakasClass();
    keikkaAsiakas.asiakasId = asiakasId;
    globalAsiakas.asiakasId = asiakasId;

    const response = await fetch(fullUrl, {
      method: "GET",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      signal: options ? options.signal : undefined,
    });
    const cResponse = await checkResponse(response, "asiakasClass.js:fetchAsiakas");
    if (!cResponse.success) return null;
    const result = cResponse.data;

    if (result.length === 0) {
      console.log("fetchAsiakas: asiakasta ei löytynyt: " + asiakasId);
      return null;
    }
    keikkaAsiakas.setDataFromJson(result.keikkaAsiakas);
    globalAsiakas.setDataFromJson(result.globalAsiakas);
    keikkaAsiakas.setSettingsFromJson(result.settings);
    globalAsiakas.setSettingsFromJson(result.settings);
    keikkaAsiakas.setModulesFromJson(result.modules);
    globalAsiakas.setModulesFromJson(result.modules);

    if (loadAuth) {
      const _auth = new authClass();
      await _auth.init(personId, keikkaId, 0, asiakasId, 0, token);
      keikkaAsiakas.auth = _auth.asiakasAuth;
      globalAsiakas.auth = _auth.asiakasAuth;
      const asiakasAuthSettings = await fetchAsiakasPersonSettings(asiakasId, personId, token);
      keikkaAsiakas.auth.settings = asiakasAuthSettings;
      globalAsiakas.auth.settings = asiakasAuthSettings;
    }

    keikkaAsiakas.isLoaded = true;
    globalAsiakas.isLoaded = true;

    const data = { keikkaAsiakas: keikkaAsiakas, globalAsiakas: globalAsiakas };
    cache_write(asiakas_cacheName, fullUrl, {
      keikkaAsiakas: keikkaAsiakas,
      globalAsiakas: globalAsiakas,
    });
    return data;
  } catch (err) {
    console.log(err);
  }
}

// hae asiakaslistaus henkilön, työmaan tai muun perusteella
export async function asiakas_fetchList(
  personId,
  asiakasId,
  filter,
  token,
  ownerAsiakasId,
  keikkaId = null
) {
  // if keikkaId is given, fetch asiakasList from dbo.keikkaAsiakas
  try {
    let url =
      "/api/asiakas/list/" +
      personId +
      "/" +
      (asiakasId || -1) +
      "/" +
      (ownerAsiakasId || -1) +
      "/" +
      (keikkaId || -1); // default: filter==="tyomaa"

    if (filter === "pumppu") url = "/api/asiakas/getPumppuToimittajaAsiakasList";
    else if (filter === "betoni") url = "/api/asiakas/getBetoniToimittajaAsiakasList";
    else if (filter === "toimittajat") url = "/api/asiakas/getToimittajaAsiakasList/" + filter;
    const cache = await cache_read(asiakas_cacheName, url);
    if (cache) return cache;
    const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "asiakasClass.js:fetchAsiakasList");
    if (!cResponse.success) return false;
    const result = cResponse.data;
    cache_write(asiakas_cacheName, url, result);
    return result;
  } catch (err) {
    console.log(err);
  }
}

export async function asiakas_addPerson(personId, asiakasId, token, contactPersonTypeId = 0) {
  cache_clear(asiakas_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      personId: personId,
      asiakasId: asiakasId,
      contactPersonTypeId: contactPersonTypeId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/asiakas/person/add",
    requestOptions
  );
  if (!(await checkResponse(response).success)) return false;
}

export async function asiakas_removePerson(personId, asiakasId, token) {
  cache_clear(asiakas_cacheName);

  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      personId: personId,
      asiakasId: asiakasId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/asiakas/person/remove",
    requestOptions
  );
  return response.ok;
}
export async function asiakas_save_to_db(
  asiakas,
  token,
  saveGlobalAsiakas = false,
  keikkaId = null
) {
  cache_clear(asiakas_cacheName);

  if (keikkaId < 0 || keikkaId == undefined) keikkaId = null;
  if (keikkaId == null) saveGlobalAsiakas = true;

  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      asiakasId: asiakas.asiakasId,
      asiakasNimi: asiakas.asiakasNimi,
      ytunnus: asiakas.ytunnus,
      kommentti: asiakas.kommentti,
      asiakasContactPersonId: asiakas.asiakasContactPersonId,
      keikkaId: keikkaId,
      saveGlobalAsiakas: saveGlobalAsiakas,
      ownerAsiakasId: asiakas.ownerAsiakasId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/asiakas/set",
    requestOptions
  );
  const cResponse = await checkResponse(response, "asiakasClass.js:saveAsiakasToDb");
  if (!cResponse.success) return false;
  const result = cResponse.data;
  return result.returnValue;
}

export async function asiakas_merge(asiakasId_keep, asiakasId_delete, token) {
  try {
    cache_clear(asiakas_cacheName);

    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        asiakasId_keep: asiakasId_keep,
        asiakasId_delete: asiakasId_delete,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/asiakas/merge",
      requestOptions
    );
    const cResponse = await checkResponse(response, "asiakasClass.js:asiakas_merge");
    if (!cResponse.success) return false;
    const result = cResponse.data;
    return result.returnValue;
  } catch (err) {
    console.log(err);
  }
}
export async function asiakas_delete(asiakasId, ownerAsiakasId, token) {
  try {
    cache_clear(asiakas_cacheName);

    const requestOptions = {
      method: "DELETE",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/asiakas/delete/" + asiakasId + "/" + ownerAsiakasId,
      requestOptions
    );
    const cResponse = await checkResponse(response, "asiakasClass.js:asiakas_delete");
    return cResponse;
  } catch (err) {
    console.log(err);
  }
}
export async function asiakasContactPerson_set(asiakasId, personId, token) {
  cache_clear(asiakas_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      asiakasId: asiakasId,
      personId: personId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/asiakas/contactPerson/set",
    requestOptions
  );
  return response.ok;
}
export async function asiakas_saveDefaultSijainti(asiakasId, sijaintiId, token) {
  cache_clear(asiakas_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      asiakasId: asiakasId,
      sijaintiId: sijaintiId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/asiakas/sijainti/varikko/saveDefaultSijainti",
    requestOptions
  );
  return response.ok;
}

export async function asiakas_asiakasLinks_fetch(asiakasId, asiakasAsiakasLinkTypeId, token) {
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const fullUrl =
    import.meta.env.VITE_SERVER_URL +
    "/api/asiakas/asiakasLinks/" +
    asiakasAsiakasLinkTypeId +
    "/" +
    asiakasId;
  const c = await cache_read(asiakas_cacheName, fullUrl);
  if (c) return c;
  const response = await fetch(fullUrl, requestOptions);
  const cResponse = await checkResponse(response, "asiakasClass.js:asiakas_asiakasLinks_fetch");
  if (!cResponse.success) return false;
  const result = cResponse.data;
  cache_write(asiakas_cacheName, fullUrl, result);
  return result;
}

export async function asiakas_asiakasLinks_delete(asiakasAsiakasLinkId, token) {
  cache_clear(asiakas_cacheName);
  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/asiakas/asiakasLinks/delete/" + asiakasAsiakasLinkId,
    requestOptions
  );
  return response.ok;
}

export async function asiakas_asiakasLinks_save(
  asiakasAsiakasLinkId,
  asiakasId,
  linkedAsiakasId,
  asiakasAsiakasLinkTypeId,
  asiakasAsiakasLinkJSON,
  comment,
  tarjousId,
  token
) {
  cache_clear(asiakas_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      asiakasAsiakasLinkId: asiakasAsiakasLinkId,
      asiakasId: asiakasId,
      linkedAsiakasId: linkedAsiakasId,
      asiakasAsiakasLinkTypeId: asiakasAsiakasLinkTypeId,
      asiakasAsiakasLinkJSON: asiakasAsiakasLinkJSON,
      comment: comment,
      tarjousId: tarjousId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/asiakas/asiakasLinks/save",
    requestOptions
  );
  return response.ok;
}
export async function asiakas_asiakasLinks_add(
  asiakasId,
  linkedAsiakasId,
  asiakasAsiakasLinkTypeId,
  token
) {
  cache_clear(asiakas_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      asiakasId: asiakasId,
      linkedAsiakasId: linkedAsiakasId,
      asiakasAsiakasLinkTypeId: asiakasAsiakasLinkTypeId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/asiakas/asiakasLinks/add",
    requestOptions
  );
  return response.ok;
}

export async function asiakasColorCodes_fetchForAllAsiakkaat(ownerAsiakasId, token) {
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const url =
    import.meta.env.VITE_SERVER_URL +
    "/api/asiakas/colorCodes/getForAllAsiakkaat/" +
    ownerAsiakasId;
  const response = await fetch(url, requestOptions);
  const cResponse = await checkResponse(
    response,
    "asiakasClass.js:asiakasColorCodes_fetchForAllAsiakkaat"
  );
  if (!cResponse.success) return false;
  const result = cResponse.data;
  return result;
}

export async function asiakasColorCode_save(asiakasId, colorCode, token) {
  cache_clear(asiakas_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      asiakasId: asiakasId,
      colorCode: colorCode,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/asiakas/colorCode/save",
    requestOptions
  );
  return response.ok;
}
